import { BedModel, BuildingModel, NodeModel } from "../models/FormDataModel";
import _ from "lodash";
import { GetDefaultParentType, TreeNodeTypes, typeOptions } from "../constants/ProConstants";
import {useBedServices} from "./useBedServices";
import { useEffect } from "react";
import { useStaffService } from "./useStaffService";
import { useHierarchyService } from "./useHierarchyService";


const useSetupForm = ({ formik, formModel}) => {

    const {data:{selectedTreeNode, currentLocation, parentsInHierarchy, parentTypes, parents, rooms}, 
         actions:{SetCurrentLocation, SetFilteredLevelTypes,  OnTypeChanged, OnBuildingChanged, OnParentTypeChanged, OnParentChanged, OnRoomChanged, UpdateLocationChangeDetail}}  = useHierarchyService();
    
    const {defaultBedStatus, defaultBedType} = useBedServices();    
    const {GetInheritedStaff} = useStaffService();

    const handleTypeChange = (type) => {
        formik.resetForm(); 
        const code = _.isObject(type)?type.code: ""
        switch (code) {
            case "BUILDING":                
                OnTypeChanged({ ...typeOptions, isBuilding: true });
                formik.setValues({ ...formik.values, model: {...BuildingModel, location:currentLocation }});
                break;
            case "FLOOR":
                OnTypeChanged({ ...typeOptions, isFloor: true });
                !_.isNumber(_.get(formik.values.model, "id")) && updateIntermediateModel(type);
                break;
            case "WING":
                OnTypeChanged({ ...typeOptions, isWing: true });
                !_.isNumber(_.get(formik.values.model, "id")) && updateIntermediateModel(type);
                break;
            case "UNIT":
                OnTypeChanged({ ...typeOptions, isUnit: true });
                !_.isNumber(_.get(formik.values.model, "id")) && updateIntermediateModel(type);
                break;
            case "ROOM":
                OnTypeChanged({ ...typeOptions, isRoom: true });
                !_.isNumber(_.get(formik.values.model, "id")) && updateIntermediateModel(type);
                break;
            case "BED":
                OnTypeChanged({ ...typeOptions, isBed: true });
                !_.isNumber(_.get(formik.values.model, "id")) && UpdateBedModel(type);
                break;
            default:
                OnTypeChanged({ ...typeOptions });
        }        

    }
    
    const updateIntermediateModel = (type)=>{   
        if(selectedTreeNode.type !== "LOCATION")
        {       
            let building = _.filter(parentsInHierarchy, (b)=> b.type === "BUILDING").pop() || null
            OnBuildingChanged(building, type.code)
            let parentType = _.filter(parentTypes, (b)=> b.code === selectedTreeNode.type).pop() || null
            OnParentTypeChanged(parentType, building.key)    
            let parent = _.filter(parents, (b)=> b.key === selectedTreeNode.key).pop() || null
            GetInheritedStaff(!parent?building.type:parent.type, !parent?building.id:parent.id).then((result)=>{
                formik.setValues({ ...formik.values, type:type, model: {...NodeModel, location:currentLocation, building:building, parentType:parentType, parent:parent, bedMngmtStaffDetails:result, isActive:!parent?building.active:parent.active} });
            })
        }
        else{
            formik.setValues({ ...formik.values, model:NodeModel});
        }
}

    const UpdateBedModel = (type)=>{
        if(selectedTreeNode.type !== "LOCATION")
        {  
            let building = _.filter(parentsInHierarchy, (b)=> b.type === "BUILDING").pop() || null
            OnBuildingChanged(building, type.code)
            let parentType = _.filter(parentTypes, (b)=> b.code === selectedTreeNode.parentId.split('-')[0]).pop() || null
            OnParentTypeChanged(parentType, building.key)    
            let parent = _.filter(parents, (b)=> b.key === selectedTreeNode.parentId).pop() || null
            OnParentChanged(parent || building)
            let room = _.filter(rooms, (b)=> b.key === selectedTreeNode.key).pop() || null
            GetInheritedStaff(!parent?building.type:parent.type, !parent?building.id:parent.id).then((result)=>{
                formik.setValues({ ...formik.values, type:type, model: {...BedModel, location:currentLocation, building:building, parentType:parentType, parent:parent, room:room, bedType:defaultBedType, bedStatus: defaultBedStatus, bedMngmtStaffDetails:result, isActive:!parent?building.active:parent.active}});
            })
        }else{
            formik.setValues({ ...formik.values, type:type, model:{...BedModel, location:currentLocation, bedType:defaultBedType, bedStatus: defaultBedStatus}});
        }
    }

   
    const onChanged = (e) => {      
       
            switch (e.target.id) {
                case "type":
                    handleTypeChange(e.target.value);
                    formik.setFieldValue("type", e.target.value);
                    break;
                case "location":                   
                    if(_.get(formik.values.model, "location") && !_.isEqual(formik.values.model.location.id, e.target.value.id))
                    {
                        UpdateLocationChangeDetail([formik.values.model.location.id, e.target.value.id])
                    }                   
                    formik.setFieldValue("model", { ...formik.values.model, location: e.target.value, building: null, 
                                        parentType: GetDefaultParentType(), parent: null,
                                        address:formik.values.model.sameAsLocationAddress?e.target.value.address:{}}, false);
                    SetCurrentLocation(e.target.value);
                    break;
                case "building":                  
                    GetInheritedStaff(e.target.value.type, e.target.value.id).then((result)=>{               
                            formik.setFieldValue("model", { ...formik.values.model, [e.target.id]: e.target.value, parentType: GetDefaultParentType(), bedMngmtStaffDetails:result,  isActive:e.target.value.active });
                    });
                    OnBuildingChanged(e.target.value, formik.values.type.code)
                    break;
                case "parentType":                   
                    GetInheritedStaff("BUILDING", formik.values.model.building.id).then((result)=>{               
                        formik.setFieldValue("model", { ...formik.values.model, [e.target.id]: e.target.value, parent: null, room:null, bedMngmtStaffDetails:result });
                    });
                    OnParentTypeChanged(e.target.value, formik.values.model.building.key)    
                    break; 
                case "parent":                   
                    GetInheritedStaff(e.target.value.type, e.target.value.id).then((result)=>{               
                        formik.setFieldValue("model", { ...formik.values.model, [e.target.id]: e.target.value, bedMngmtStaffDetails:result, isActive:e.target.value.active });
                    });
                    OnParentChanged(e.target.value);
                    break;
                case "room":                  
                    GetInheritedStaff(e.target.value.type, e.target.value.id).then((result)=>{               
                        formik.setFieldValue("model", { ...formik.values.model, [e.target.id]: e.target.value, bedMngmtStaffDetails:result, isActive:e.target.value.active });
                    });
                    OnRoomChanged(e.target.value);
                    break; 
                case "bedMngmtStaffDetails":
                    const parentElement = _.get(formik.values.type, "code") === 'BED'?formik.values.model.room
                                            :_.isNull(formik.values.model.parent)?formik.values.model.building
                                            : formik.values.model.parent;
                    if(!_.isEmpty(parentElement)){
                        GetInheritedStaff(parentElement.type, parentElement.id).then((result)=>{  
                            formik.setFieldValue("model", { ...formik.values.model, [e.target.id]: _.unionBy(result, e.target.value, 'id') });
                    })
                    }
                    else{
                        formik.setFieldValue("model", { ...formik.values.model, [e.target.id]: e.target.value });
                    }
                break;
                case "sameAsLocationAddress":
                    e.target.checked? formik.setFieldValue("model", { ...formik.values.model, 
                        address:_.get(formik.values.model.location, "address")?formik.values.model.location.address : {},                       
                        sameAsLocationAddress: e.target.checked})
                        :formik.setFieldValue("model", { ...formik.values.model, 
                            address: {},                       
                            sameAsLocationAddress: e.target.checked})
                    break   
                case "isActive":  
                    formik.setFieldValue("model", { ...formik.values.model, [e.target.id]: e.target.checked }); 
                        break;
                default:
                    formik.setFieldValue("model",
                     { ...formik.values.model, [e.target.id]: _.isObject(e.target.value)? e.target.value 
                                                            : _.isEqual(e.target.id, "bedCapacity")?parseInt(e.target.value) || 0
                                                            : _.trimStart(e.target.value) });
            }      
       
    }    
    


   
    useEffect(()=>{
        if(!_.isEmpty(formModel))
        {
            handleTypeChange(formModel.type)
            SetFilteredLevelTypes(TreeNodeTypes.filter(n=> _.isEqual(n.name, formModel.type.name)))
            formik.setValues(formModel)
            !_.isEmpty(formModel.model.building) && OnBuildingChanged(formModel.model.building, formModel.type.code)
            !_.isEmpty(formModel.model.parentType) && OnParentTypeChanged(formModel.model.parentType, formModel.model.building.key)    
            !_.isEmpty(formModel.model.parent) && OnParentChanged(formModel.model.parent)
           
        }
        else{
            handleTypeChange("")
        }

    }, [])//No Dependency.
    
   
    return { onChanged };
};

export default useSetupForm;
